import React, { useContext, useState } from "react";
import "./profile.css";
import OverflowToolTip from "../shared/OverflowToolTip";
import linkedin from "../../Utils/linkedin.png";
import { TableHeaderContext } from "../../Contexts/TableHeaderContext";
import Highlights from "./Highlights";
import { Skeleton, Tooltip, Modal } from "antd";
import { MdEmail } from "react-icons/md";
import { PhoneOutgoing, X } from "lucide-react";
import { useManagementPhoneAccess } from "../../hooks/useManagementPhoneAccess";
import { useParams } from "react-router-dom";
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';
import { UserContext } from "../../Contexts/UserContext";
import { CurrencyContext } from "../../Contexts/CurrencyContext";
import PdfDownloader from "../shared/PdfDownloader";
import Constants from "../../Constants";
import { exportPdf } from "../../Config/config";
import PopupHandler from "../AISummaryPopup";
import { fetchAISummary } from "../useGetProfileDetails";
import { TableDataContext } from "../../Contexts/TableDataContext";
import { NavLink } from "react-router-dom";
import { routeNames } from "../../routeSegments";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  ChartTooltip,
  Legend
);

function ProfileHighlight({ profile, financials, menu, fieldsOnly = false }) {

  const { profilekeys } = useContext(TableHeaderContext);
  const [showContactPopup, setShowContactPopup] = useState(false);
  const { companyId } = useParams();

  const {
    showConfirmPopup,
    showPaymentPopup,
    phoneNumbers,
    loadingPhone,
    showEmailOptions,
    onGetPhoneNumber,
    confirmPopup,
    paymentPopup,
    emailSelector,
  } = useManagementPhoneAccess(companyId, "company");
  
  const {data} = useContext(TableDataContext);
  
  console.log(data?.cfs_profile?.epfo_data,"itit")
  const epfo_data = data?.cfs_profile?.epfo_data || [];
  
  // Format quarter string from "2025Q1" to "Q1' 25"
  const formatQuarterString = (quarterStr) => {
    if (!quarterStr) return '';
    const [year, quarter] = quarterStr.split('Q');
    return `Q${quarter}' ${year.slice(2)}`;
  };
  
  // Sort epfo_data by year and quarter ascending for chart x-axis
  const sortedEpfoData = epfo_data.slice().sort((a, b) => {
    const [yearA, quarterA] = a.qrtr.split('Q').map(Number);
    const [yearB, quarterB] = b.qrtr.split('Q').map(Number);
    return yearA - yearB || quarterA - quarterB;
  });
  
  // Get latest 5 quarters for the chart
  const latestFiveQuarters = sortedEpfoData.slice(-5);
  
  // Get latest entry for display (descending sort)
  const latestEntry = epfo_data.slice().sort((a, b) => {
    const [yearA, quarterA] = a.qrtr.split('Q').map(Number);
    const [yearB, quarterB] = b.qrtr.split('Q').map(Number);
    return yearB - yearA || quarterB - quarterA;
  })[0];

  // Add Employee Count accessor to profilekeys at the end
  const extendedProfileKeys = [
    ...profilekeys,
    { 
      accessor: "employee_count", 
      label: latestEntry?.qrtr ? `Employee Count (${formatQuarterString(latestEntry?.qrtr)})` : "Employee Count"
    }
  ];
  const renderBoardInfo = (boardInfo) => {
    if (!boardInfo || boardInfo.length === 0) return null;

    
    const concatenatedInfo = boardInfo
    .map(info => `${info.name} (${info.designation})`)
    .join(", ");

    if (concatenatedInfo?.length > 29) {
      return (
        <Tooltip
          color="white"
          title={
            <div style={{ color: 'black' }}>
              {boardInfo.map((info, index) => {
                const name = info.name;
                const additionalInfo = [info.designation, info.belongs_to_firm_name].filter(Boolean).join(', ');
                const searchQuery = additionalInfo ? `${name} ${additionalInfo} site:linkedin.com` : `${name} site:linkedin.com`;
                return (
                  <p key={index} className="my-1">
                    <a
                      href={`https://www.google.com/search?q=${encodeURIComponent(searchQuery)}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#a07924] hover:text-[#a07924]"
                    >
                      {name}
                    </a>
                    {additionalInfo && `, ${additionalInfo}.`}
                  </p>
                );
              })}
            </div>
          }
          placement="topLeft"
        >
          <a className="text-[#a07924]">
            {boardInfo[0].name},
          </a>
          <span> {boardInfo[0].designation}{concatenatedInfo.length > 23 && "..."}</span>
        </Tooltip>
      );
    } else {
      return boardInfo.map((info, index) => {
        const name = info.name;
        const additionalInfo = [info.designation, info.belongs_to_firm_name].filter(Boolean).join(', ');
        const searchQuery = additionalInfo ? `${name} ${additionalInfo} site:linkedin.com` : `${name} site:linkedin.com`;
        return (
          <p key={index} className="my-1">
            <a
              href={`https://www.google.com/search?q=${encodeURIComponent(searchQuery)}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#a07924]"
            >
              {name}
            </a>
            {additionalInfo ? ', ' + additionalInfo : ""}
          </p>
        );
      });
    }
  };

  const { currencyType, currency, isDetailed } = useContext(CurrencyContext);
  const { isStudent } = useContext(UserContext);

   const {
    pe_investments = [],
    angel_investments = [],
    incubation_investments = [],
    pe_exits = [],
    pe_ipos = []
  } = financials?.private_equity || {};

  const financialsLen = financials?.profit_loss || [];

  const totalDeals =
    pe_investments.length + angel_investments.length + incubation_investments.length + pe_exits.length + pe_ipos.length;

  const enableAiSummary = totalDeals >= 3 && financialsLen?.length > 0;

  const [showAIPopup, setShowAIPopup] = useState(false);
  const [showEmployeeChart, setShowEmployeeChart] = useState(false);

  // Chart data for employee count - Bar Chart
  const employeeChartData = {
    labels: latestFiveQuarters.map(e => formatQuarterString(e.qrtr)),
    datasets: [
      {
        label: 'Employee Count',
        data: latestFiveQuarters.map(e => e.employees),
        backgroundColor: '#bc8b20',
        borderColor: '#bc8b20',
        borderWidth: 1,
        barThickness: 25, // Control the width of the bars (increased from 20)
        maxBarThickness: 30, // Maximum bar width (increased from 25)
        borderRadius: 3, // Slightly rounded corners
      },
    ],
  };

  const employeeChartOptions = {
    responsive: true,
    maintainAspectRatio: false, // Allows custom height control
   
    scales: {
      x: { 
        // title: { display: true, text: 'Quarter' },
        ticks: {
          maxRotation: 0,
          minRotation: 0,
          font: {
            size: 11
          }
        },
        grid: {
          display: false
        },
        categoryPercentage: 0.8, // Controls spacing between groups of bars (increased from 0.7)
        barPercentage: 0.9, // Controls width of bars relative to category space (increased from 0.8)
      },
      y: { 
        // title: { display: true, text: 'Employees' }, 
        beginAtZero: true,
        ticks: {
          stepSize: Math.ceil(Math.max(...latestFiveQuarters.map(e => e.employees)) / 10) || 1
        },
        grid: {
          color: 'rgba(0, 0, 0, 0.1)'
        }
      },
    },
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        enabled: true,
        displayColors: false,
        yAlign : 'bottom',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        titleColor: '#000000',
        bodyColor: '#000000',
        borderColor: '#000000',
        borderWidth: 1,
        callbacks: {
          title: () => {
            return '';
          },
          label: (tooltipItem) => {
            return tooltipItem.parsed.y;
          }
        }
      }
    }
  };

  return (<>
    <div className={fieldsOnly ? "" : "lg:mt-4 px-4 w-[100%]"}>
      <div className={fieldsOnly ? "" : "lg:bg-white rounded-[6px]"} x-show="tab === 1">
        <div className={fieldsOnly ? "" : "w-full lg:grid lg:grid-cols-5 rounded-[6px] shadow-[0_2px_6px_0_rgba(0,0,0,0.08)]"}>
          <div className={fieldsOnly ? "" : "mt-3 lg:mt-0 rounded-lg lg:rounded col-span-3 lg:border-r bg-white "}>
            <div className={fieldsOnly ? "" : "mx-5 py-4 "}>
              {!fieldsOnly && (
              <div className="flex flex-row justify-start items-center gap-4">
                <p className="text-[14pt] flex leading-[19pt] lg:text-[17px] text-[#333333] font-semibold  lg:leading-[22px]">
                  Profile
                  {profile?.linkedin ? ( // Check if LinkedIn profile value exists
                    <a
                      href={`${profile?.linkedin}`}
                      target="_blank"
                      className="mt-[0.20rem] ml-2"
                    >
                      <img src={linkedin} width={17} alt="linkedin logo" />
                    </a>
                  ) : (
                    ""
                  )}
                </p>
                  <p className="px-[0.25rem] text-xs lg:text-[12px] font-semibold border border-[#0077B7] bg-[#0077B7] rounded-sm text-white cursor-pointer">
                    <PdfDownloader
                        url={exportPdf}
                        fileName={profile.name?.replaceAll(/\s/g, "_")}
                        data={{
                          entity_id: profile.id,
                          type_id: Constants.moduleIds.companiesId,
                          is_detailed: isDetailed,
                          currency_cd: currencyType,
                          display_in: currency,
                          ma_deal_ids: financials?.merger_acquisition?.map(item => item?.id) || [],
                          deal_ids: financials?.private_equity?.pe_investments?.map(item => item?.id) || [],
                          deal_exits_ids: financials?.private_equity?.pe_exits?.map(item => item?.id) || [],
                          deal_ipo_ids: financials?.private_equity?.pe_ipos?.map(item => item?.id) || [],
                          deal_angel_ids: financials?.private_equity?.angel_investments?.map(item => item?.id) || [],
                          deal_inc_ids: financials?.private_equity?.incubation_investments?.map(item => item?.id) || [],
                          type:
                            menu == "pe"
                              ? Constants.primaryMasterIds.peId
                              : menu == "vc"
                              ? Constants.primaryMasterIds.vcId
                              : menu == "re"
                              ? Constants.primaryMasterIds.reId
                              : menu == "ma"
                              ? Constants.primaryMasterIds.mANDaId
                              : menu == "cfs"
                              ? Constants.primaryMasterIds.cfsId
                              : 6,
                        }}
                        children={"Tear Sheet"}
                      />
                  </p>
                  {enableAiSummary &&
                    <NavLink className="relative px-[0.25rem] text-xs lg:text-[12px] font-semibold border border-[#0077B7] bg-[#0077B7] rounded-sm text-white cursor-pointer"
                      to={routeNames.aISummary(profile.id)}
                      target="_blank"
                    >
                      <span className="text-xs text-red-700 absolute -top-3 -right-7">Beta</span>
                      AI Summary
                    </NavLink>
                  }
              </div>
              )}
              <div className="mt-2">
                {profile?.length === 0 ? (
                  <div className="overflow-x-auto lg:overflow-x-hidden overflow-y-hidden lg:overflow-y-hidden">
                    <table className="h-[10rem] w-full bg-[#FFFFFF] ">
                      <center>
                        <div role="status" className="bg-white  h-[16rem]">
                          <svg
                            className="relative top-[6rem] inline mr-2 w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#CA8A24]"
                            viewBox="0 0 100 101"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                              fill="currentColor"
                            />
                            <path
                              d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                              fill="currentFill"
                            />
                          </svg>
                        </div>
                      </center>
                    </table>
                  </div>
                ) : (
                  <div className="overflow-x-auto lg:overflow-x-hidden overflow-y-hidden lg:overflow-y-hidden">
                    <div className="w-full bg-[#FFFFFF]">
                      <div className={fieldsOnly ? "grid grid-cols-2 break-words" : "grid md:grid-cols-3 grid-cols-2  break-words"}>
                        {extendedProfileKeys.map((keyObj, index) => {
                          const key = keyObj.accessor;
                          const label = keyObj.label;
                          let valueToRender = null;

                          if (key === "management_info") {
                            const managementInfo = profile[key];
                              if (managementInfo && managementInfo?.count > 0) {
                                valueToRender = (
                                  <>
                                    <div>
                                      {managementInfo?.data?.slice(0, 1)
                                        .map((info, i) => (
                                          <div key={i} style={{whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis"}} className="flex gap-1 flex-wrap items-center">
                                            {managementInfo?.count === 1 && info.email ? (
                                              <span className="text-[#0077b7] cursor-pointer" onClick={() => setShowContactPopup(true)}>{info.name}, {info.designation}</span>
                                            ) : (
                                              `${info.name}, ${info.designation}`
                                            )}
                                              {managementInfo?.count > 1 && ( <span className="text-[#0077b7] cursor-pointer"  onClick={() => setShowContactPopup(true)}>
                                                {` & ${managementInfo?.count - 1} more`}
                                              </span> )}
                                          </div>
                                        ))
                                      }
                                    </div>
                                    {showContactPopup && (
                                    <div
                                      style={{
                                        position: 'fixed',
                                        top: 0,
                                        left: 0,
                                        width: '100vw',
                                        height: '100vh',
                                        background: 'rgba(0,0,0,0.35)',
                                        zIndex: 9999,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                      }}
                                      onClick={() => setShowContactPopup(false)}
                                    >
                                      <div
                                        className="relative bg-white p-8 pt-0 rounded-lg"
                                        style={{ minWidth: 900, maxWidth: 1500, boxShadow: '0 2px 12px rgba(0,0,0,0.15)' }}
                                        onClick={e => e.stopPropagation()}
                                      >
                                        <div className="py-4 flex justify-end">
                                            <button
                                                onClick={() => setShowContactPopup(false)}
                                                className="rounded-full p-1 hover:bg-gray-100 transition-colors"
                                            >
                                                <X className="h-5 w-5 text-gray-500" />
                                            </button>
                                        </div>
                                        <div style={{ overflowX: 'auto' }}>
                                          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
                                            <thead>
                                              <tr style={{ background: '#ffffffff' }}>
                                                <th style={{ padding: '6px 8px', border: '1px solid #ffffffff', textAlign: 'left' }}>Name</th>
                                                <th style={{ padding: '6px 8px', border: '1px solid #ffffffff', textAlign: 'left' }}>Designation</th>
                                                <th style={{ padding: '6px 8px', border: '1px solid #ffffffff', textAlign: 'left' }}>Email</th>
                                                <th style={{ padding: '6px 8px', border: '1px solid #ffffffff', textAlign: 'left' }}>Phone</th>
                                                <th style={{ padding: '6px 10px', border: '1px solid #ffffffff', textAlign: 'left' }}>LinkedIn</th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {managementInfo?.data?.map((info, idx) => (
                                                <tr key={idx}>
                                                  <td style={{ padding: '6px 8px', border: '1px solid #ffffffff' }}>{info.name || '-'}</td>
                                                  <td style={{ padding: '6px 8px', border: '1px solid #ffffffff' }}>{info.designation || '-'}</td>
                                                  <td style={{ padding: '6px 8px', border: '1px solid #ffffffff' }}>
                                                    {info.email ? <a href={`mailto:${info.email}`}>{info.email}</a> : '-'}
                                                  </td>
                                                  <td style={{ padding: '6px 8px', border: '1px solid #ffffffff' }}>
                                                    {phoneNumbers[idx] || info?.phone ? (
                                                      <span>{phoneNumbers[idx] || info.phone}</span>
                                                    ) : (
                                                      <div
                                                        onClick={() => onGetPhoneNumber(info, idx)}
                                                        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '4px' }}
                                                        title="Click to reveal phone number"
                                                      >
                                                        {loadingPhone[idx] ? (
                                                          <span style={{ fontSize: '12px', color: '#9CA3AF' }}>Loading...</span>
                                                        ) : (
                                                          <PhoneOutgoing size={16} style={{ color: '#10B981' }} />
                                                        )}
                                                      </div>
                                                    )}
                                                  </td>
                                                  <td style={{ padding: '6px 20px', border: '1px solid #ffffffff' }}>
                                                    {info.linkedin_url ? (
                                                      <a href={info.linkedin_url} target="_blank" rel="noopener noreferrer">
                                                        <img src={linkedin} width={16} alt="linkedin logo" />
                                                      </a>
                                                    ) : '-'}
                                                  </td>
                                                </tr>
                                              ))}
                                            </tbody>
                                          </table>
                                        </div>
                                        <div className="flex justify-end">
                                          <button
                                            style={{ marginTop: 12, background: '#a07924', color: 'white', border: 'none', borderRadius: 4, padding: '4px 16px', cursor: 'pointer', fontSize: 13 }}
                                            onClick={() => setShowContactPopup(false)}
                                          >
                                            Close
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </>
                              );
                            } else valueToRender = null;
                          } else if (key === "board_info") {
                            valueToRender = renderBoardInfo(profile[key]);
                          } else if (key === "city") {
                            const city = profile[key];

                            if (city && city.name || city?.city) {
                                // Initialize an array to hold the parts of the address
                                const parts = [];

                                // Check each property and add it to the parts array if it's not null or empty
                                if (city.name) parts.push(city.name);
                                if (city.state) parts.push(city.state);
                                if (city.region) parts.push(city.region);
                                if (city.country) parts.push(city.country);

                                // Join the parts with a comma and space, or use "--" if no valid parts exist
                                valueToRender = parts.length > 0 ? parts.join(', ') : '--';
                            } else {
                                valueToRender = '--';
                            }
                          } else if (key === "employee_count") {
                            // Render Employee Count as '2024Q4(21)' and add chart popup on hover/click
                            valueToRender = latestEntry && latestEntry.qrtr && latestEntry.employees !== undefined
                              ? (
                                <Tooltip
                                  title={<span style={{ color: 'black' }}>Click to view employee count chart</span>}
                                  color="white"
                                >
                                  <span
                                    style={{ cursor: 'pointer', color: '#bc8b20', fontWeight: 600 }}
                                    onClick={() => setShowEmployeeChart(true)}
                                    // onMouseEnter={() => setShowEmployeeChart(true)}
                                  >
                                    {latestEntry.employees} 
                                  </span>
                                </Tooltip>
                              )
                              : null;
                          } else if (key === "website"){
                            valueToRender = menu === "ma" && profile[key] == "" ? "--" : profile[key] === "" ? null : profile[key];
                          }else {
                            valueToRender =
                              profile[key] && profile[key] !== ""
                                ? profile[key]
                                : null;
                          }
                          if (valueToRender !== null) {
                            return (
                              <div key={index} className="pr-4">
                                <>
                                  {typeof valueToRender === "string" && valueToRender.length > 30 ? (
                                    <div className="leading-[21px] font-sans_book_body mt-1">
                                      <div className=" block lg:overflow-x-clip lg:overflow-ellipsis lg:whitespace-nowrap md:max-w-[14rem]">
                                        <span
                                          className="py-1 text-[10pt] lg:whitespace-nowrap leading-[18pt] lg:text-[13px] text-[#333333] cursor-auto"
                                          readOnly
                                        >
                                          {label}
                                        </span>
                                      </div>
                                      <Tooltip
                                        title={
                                          <>
                                            <div className=" block lg:overflow-x-clip lg:overflow-ellipsis lg:whitespace-nowrap md:max-w-[14rem]">
                                              <span
                                                className="py-1 text-[10pt] lg:whitespace-nowrap leading-[18pt] lg:text-[13px] text-[#333333] cursor-auto"
                                                readOnly
                                              >
                                                {label}
                                              </span>
                                            </div>
                                            {label === "Website" ? (
                                              <a
                                                href={valueToRender}
                                                className="mt-1 mb-2 hover:text-[#bc8b20] text-[10pt] leading-[18pt] lg:text-[13px] text-[#333333] cursor-pointer font-semibold"
                                                target="_blank"
                                              >
                                                {valueToRender}
                                              </a>
                                            ) : (
                                              <p
                                                className="mt-1 mb-2 text-[10pt] leading-[18pt] lg:text-[13px] text-[#333333] cursor-auto font-semibold"
                                                readOnly
                                              >
                                                {valueToRender}
                                              </p>
                                            )}
                                          </>
                                        }
                                        color="white"
                                        placement="topLeft"
                                      >
                                        {label === "Website" ? (
                                          <p
                                            className="w-[90%] overflow-ellipsis overflow-hidden whitespace-nowrap mt-1 mb-2 text-[10pt] leading-[18pt] lg:text-[13px] text-[#333333] cursor-auto font-semibold"
                                            readOnly
                                          >
                                            <a
                                            href={valueToRender}
                                            target="_blank"
                                            >
                                              {valueToRender}
                                            </a>
                                          </p>
                                        ) : (
                                          <p
                                            className="w-[90%] overflow-ellipsis overflow-hidden whitespace-nowrap mt-1 mb-2 text-[10pt] leading-[18pt] lg:text-[13px] text-[#333333] cursor-auto font-semibold"
                                            readOnly
                                          >
                                            {valueToRender}
                                          </p>
                                        )}
                                      </Tooltip>
                                    </div>
                                  ) : (
                                    <div className="leading-[21px] font-sans_book_body mt-1">
                                      <div className=" block lg:overflow-x-clip lg:overflow-ellipsis lg:whitespace-nowrap md:max-w-[14rem]">
                                        <span
                                          className="py-1 text-[10pt] lg:whitespace-nowrap leading-[18pt] lg:text-[13px] text-[#333333] cursor-auto"
                                          readOnly
                                        >
                                          {label}
                                        </span>
                                      </div>
                                      {label === "Website" ? (
                                        <a
                                          href={valueToRender}
                                          className="mt-1 mb-2 text-[10pt] leading-[18pt] lg:text-[13px] text-[#333333] cursor-pointer font-semibold"
                                          target="_blank"
                                        >
                                          {valueToRender}
                                        </a>
                                      ) : (
                                        <p
                                          className="mt-1 mb-2 text-[10pt] leading-[18pt] lg:text-[13px] text-[#333333] cursor-auto font-semibold"
                                          readOnly
                                        >
                                          {valueToRender}
                                        </p>
                                      )}
                                    </div>
                                  )}
                                </>
                              </div>
                            );
                          } else {
                            return null;
                          }
                        })}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
          {/* <!--first half end--> */}
          {!fieldsOnly && <Highlights financials={financials} menu={menu} />}

          {/* <!--end--> */}
        </div>
      </div>
    </div>
    <Modal
      open={showEmployeeChart}
      onCancel={() => setShowEmployeeChart(false)}
      footer={null}
      title="Employee Count"
      width={600}
    >
      <div style={{ marginBottom: '10px', textAlign: 'center', color: '#666',paddingTop: '6px' }}>
        
      </div>
      <div style={{ height: '300px', padding: '10px', position: 'relative' }}>
        <Bar data={employeeChartData} options={employeeChartOptions} />
        <div style={{ 
          position: 'absolute', 
          bottom: '-12px', 
          right: '-11px', 
          fontSize: '11px', 
          color: '#666',
          fontStyle: 'italic'
        }}>
          Source: Labour filings
        </div>
      </div>
    </Modal>
    {showConfirmPopup && confirmPopup()}
    {showPaymentPopup && paymentPopup()}
    {showEmailOptions && emailSelector()}
    </>
  );
}

export default ProfileHighlight;